import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module';

import { Page } from './page.component';
import { PageHeader } from './page-header.component';
import { StackModule } from '../stack/stack.module';

@NgModule({
  declarations: [
    Page,
    PageHeader,
  ],
  exports: [
    Page,
    PageHeader,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BreadcrumbModule,
    StackModule,
  ]
})
class PageModule { }

export {
  PageModule,
  Page
};
